import styled from '@emotion/styled';

import { color, font, layout, mediaQueries } from 'src/shared/styles/variables';

interface MusicPlayerProps {
    buttonOnly?: boolean;
    isPlaying?: boolean;
    color?: string;
    centered?: boolean;
}

export const PlaybackInfo = styled('div')({
    display: 'flex',
    alignItems: 'center',
    maxWidth: '40rem',
    width: '100%',
    [mediaQueries.lg]: {
        maxWidth: '35rem',
    },
    [mediaQueries.sm]: {
        maxWidth: '15rem',
    },
});

export const PlayerWrapper = styled('div')<MusicPlayerProps>(props => ({
    backgroundColor: props.buttonOnly ? 'transparent' : props.color || 'transparent',
    position: 'relative',
    width: '100%',
    height: props.buttonOnly ? 'auto' : 163,
    '& > svg': {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
    },
}));

export const PlayerContent = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: layout.containerSmallerWidth,
    backgroundPositionX: 'right',
    backgroundRepeat: 'no-repeat',
    height: '100%',
    margin: '0 auto',
});

export const PlayPauseButton = styled('button')<MusicPlayerProps>(
    props => ({
        color: props.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        borderRadius: 26.5,
        height: '4rem',
        width: props.buttonOnly ? '4rem' : '17rem',
        marginBottom: props.isPlaying ? '1rem' : 0,
        backgroundColor: props.buttonOnly ? props.color : color.white,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: props.buttonOnly ? 'center' : 'left 30% center',
        transition: 'background-color 0.2s',
        '& span': {
            paddingTop: 6,
            paddingLeft: 10,
        },
        '&:hover': {
            backgroundColor: props.buttonOnly ? color.blueLagoon : color.white,
        },
        [mediaQueries.md]: {
            fontSize: font.size.medium,
            width: props.buttonOnly ? '4rem' : '10rem',
            backgroundSize: 14,
            backgroundPosition: 'left 20% center',
            '& svg': {
                height: 18,
                width: 18,
            },
        },
    }),

    font.medium(font.size.largeExtended),
);

export const PlayerControls = styled('div')<MusicPlayerProps>(props => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: props.centered ? 'center' : 'flex-start',
    width: '100%',
    padding: props.buttonOnly ? '0 1rem' : 0,
    flexDirection: props.buttonOnly ? 'column' : 'row',
    zIndex: 3,
    [mediaQueries.md]: props.isPlaying && {
        flexDirection: 'column',
    },
    [mediaQueries.sm]: {
        '& .progressBar-wrapper': {
            marginLeft: 0,
        },
    },
}));

export const TotalLength = styled('span')(
    {
        lineHeight: 2,
        color: color.white,
        paddingLeft: '2rem',
    },
    font.medium(font.size.largeExtended),
);

export const TimeToEnd = styled('span')<MusicPlayerProps>(props => ({
    ...font.medium(props.buttonOnly ? font.size.base : font.size.mediumExtended),
    color: props.buttonOnly ? color.mamba : color.white,
}));
